import { useState } from 'react'
import { useLocation } from 'wouter'

// Hook personalizado `useFetch` para realizar peticiones API y manejar su estado
export default function useFetch() {
  // Wouter - useLocation() permite cambiar de pantalla
  const [, setLocation] = useLocation()

  // Estados que gestionan el proceso de la petición:
  const [loading, setLoading] = useState(false)
  const [isCalled, setIsCalled] = useState(false)
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [message, setMessage] = useState(null)

  // Función `fetchAction` que realiza la petición API
  async function fetchAction(params) {
    // Reinicia los estados antes de realizar la nueva solicitud
    setIsCalled(true)
    setData(null)
    setError(null)
    setMessage(null)
    setLoading(true)

    // Credenciales API:
    const apiCredentials = `Basic ${btoa(
      process.env.REACT_APP_API_USERNAME +
        ':' +
        process.env.REACT_APP_API_PASSWORD
    )}`

    try {
      // Define las cabeceras de la solicitud en función de si se envían datos `formData` o no
      const headers = params.formData
        ? { Accept: 'multipart/form-data', Authorization: apiCredentials }
        : { 'Content-Type': 'application/json', Authorization: apiCredentials }

      // Define el cuerpo de la solicitud dependiendo de si es `formData` o un objeto JSON
      const body = params.formData
        ? params.formData
        : JSON.stringify(params.body)

      // Realiza la solicitud `fetch` a la API
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/${params.url}`,
        {
          method: params.method,
          headers,
          body
        }
      )

      // Si la respuesta es exitosa (status 200)
      if (response.ok) {
        const responseData = await response.json() // Obtiene los datos de la respuesta
        setData(responseData) // Almacena los datos
        setMessage(responseData.message) // Almacena el mensaje de la respuesta
      }

      // Si la respuesta no es exitosa
      if (!response.ok) {
        // Si el error es 401 (no autorizado) y no es una solicitud de autenticación, redirige a login
        if (!params.url.includes('auth') && response.status === 401) {
          setLocation('/login')
        } else {
          // Si es otro error, guarda el error de la respuesta
          const errorData = await response.json()
          setError(errorData.error)
          console.log(
            'useFetch() detailedError from API call fail: ',
            errorData.detailedError
          )
        }
      }
    } catch (error) {
      setError(error) // Si ocurre un error durante la solicitud, se almacena el error
    } finally {
      setLoading(false) // Independientemente del resultado, se indica que la solicitud ha terminado
    }
  }

  // Retorna un array con el estado actual de la solicitud y la función `fetchAction`
  return [
    {
      loading, // Estado de carga
      isCalled, // Indica si la función fue llamada
      data, // Datos de la respuesta
      error, // Errores de la respuesta
      message // Mensajes de la respuesta
    },
    fetchAction // Función para realizar la solicitud
  ]
}
